"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButton = void 0;
const class_variance_authority_1 = require("class-variance-authority");
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const utils_1 = require("../../lib/utils");
const Button_1 = require("./Button");
const ButtonBase_1 = require("./ButtonBase");
const LinkButton = React.forwardRef(({ className, children, color, size, LeftIcon, RightIcon, ...props }, ref) => {
    return (React.createElement(react_router_dom_1.Link, { className: (0, utils_1.cn)((0, class_variance_authority_1.cx)((0, ButtonBase_1.buttonBaseVariants)({ color }), (0, Button_1.buttonVariants)({ size, className }))), ref: ref, ...props },
        LeftIcon && React.createElement(LeftIcon, { className: "tw-h-4 tw-w-4" }),
        children,
        RightIcon && React.createElement(RightIcon, { className: "tw-h-4 tw-w-4" })));
});
exports.LinkButton = LinkButton;
LinkButton.displayName = "LinkButton";
